'use client';

import React, { useState } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { Search, Menu,User } from 'lucide-react';
import { useAddressStore } from '@/store/address-store';
import MobileAddressBar from '@/components/ui/mobile-address-bar';
import { Input } from '@/components/ui/input';
import Image from 'next/image';
import Link from 'next/link';
import { Sheet, SheetTrigger, SheetContent, SheetClose } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/use-auth';
import { useUserStore } from '@/store/user-store';
import { CartFooter } from '../cart-footer/cart-footer';



export const MobileHeader: React.FC = () => {
  const router = useRouter();
  const pathname = usePathname();

  const { address, setAddress } = useAddressStore();
  const [searchQuery, setSearchQuery] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLocating, setIsLocating] = useState(false);
  
  // Get authentication state
  const { status, session, signOut } = useAuth();
  const userStore = useUserStore();
  
  // Check various page types
  const isHomePage = pathname === '/';
  const isSearchPage = pathname === '/search';
  
  // Combined authentication state from both auth systems
  const nextAuthAuthenticated = status === 'authenticated';
  const zustandAuthenticated = userStore.isAuthenticated;
  const isAuthenticated = nextAuthAuthenticated || zustandAuthenticated;
  
  // User data (prioritize next-auth if available)
  const user = nextAuthAuthenticated 
    ? { name: session?.user?.name || 'User', email: session?.user?.email || '' } 
    : userStore.user;
  
  const handleAddressClick = () => {
    // Open address selector or navigate to address selection page
    router.push('/search?select-address=true');
  };
  
  
  // Handle logout
  const handleLogout = async () => {
    try {
      if (nextAuthAuthenticated) {
        await signOut({ redirect: false });
      }
      
      if (zustandAuthenticated) {
        userStore.logout();
      }
      
      window.location.href = '/';
      setIsMenuOpen(false);
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };
  
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      router.push(`/search?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  // Render different header for home page vs other pages
  return (
    <div className="md:hidden">
      {window.location.href.split('/').pop() != 'cart' && <CartFooter/>}
      {isHomePage ? (
        /* Home page header with logo and hamburger */
        <div className="bg-white shadow-sm px-4 py-3 flex items-center justify-between">
          <Link href="/" className="relative h-8 w-24 flex-shrink-0">
            <Image
              src="/logo.png"
              alt="Qmin"
              fill
              className="object-contain"
              priority
            />
          </Link>
         
          {/* {sAuthenticated &&  (
          <div className="flex items-center space-x-3">
            <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="p-2 text-gray-700 hover:bg-gray-100 rounded-full">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[90%] max-w-[350px] p-0 overflow-y-auto">
                <div className="flex flex-col h-full bg-white">

                  <div className="flex items-center justify-between px-4 pt-6 pb-4 border-b border-gray-100">
                    <h2 className="text-xl font-bold text-[#900f21]">Menu</h2>
                  </div>


                  <div className="px-4 py-6 border-b border-gray-100">
                    {isAuthenticated ? (
                      <div className="flex flex-col space-y-4">
                        <div className="flex items-center">
                          <div className="h-12 w-12 bg-[#8a6d3b] text-white rounded-full flex items-center justify-center text-xl font-bold mr-3">
                            {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                          </div>
                          <div>
                            <div className="font-medium">{user?.name || 'User'}</div>
                            <div className="text-sm text-gray-500">{user?.email || ''}</div>
                          </div>
                        </div>
                        <SheetClose asChild>
                          <Link 
                            href="/profile"
                            className="text-[#900f21] font-medium"
                          >
                            View Profile
                          </Link>
                        </SheetClose>
                      </div>
                    ) : (
                      <SheetClose asChild>
                        <Link href="/login-page">
                          <Button 
                            className="bg-[#900f21] hover:bg-[#900f21]/90 text-white w-full rounded-md py-2.5 font-medium"
                          >
                            Login
                          </Button>
                        </Link>
                      </SheetClose>
                    )}
                  </div>


                  <nav className="flex flex-col px-4 py-2">
                    <SheetClose asChild>
                      <Link
                        href="/restaurants"
                        className="text-gray-900 hover:text-[#900f21] font-medium text-lg py-3 border-b border-gray-100"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Restaurants
                      </Link>
                    </SheetClose>
                  </nav>


                  {isAuthenticated && (
                    <div className="mt-auto p-4 border-t border-gray-100">
                      <SheetClose asChild>
                        <Button 
                          variant="outline" 
                          className="w-full justify-center rounded-md text-red-600 border-red-200 hover:bg-red-50"
                          onClick={handleLogout}
                        >
                          Logout
                        </Button>
                      </SheetClose>
                    </div>
                  )}
                </div>
              </SheetContent>
            </Sheet>
          </div>)} */}
        </div>
      ) : (
        /* Inner pages header with address and search */
        <>
          {/* Red header with address bar component */}
          <div className="bg-[#900f21] text-white px-4 pt-5 pb-4">
            <MobileAddressBar />
          </div>
        </>
      )}
    </div>
  );
};

export default MobileHeader;
